const blogCategories = [
  { name: "Fantasy", slug: "fantasy" },
  { name: "Science Fiction", slug: "science-fiction" },
  { name: "Adventure", slug: "adventure" },
  { name: "Mystery", slug: "mystery" },
  { name: "Horror", slug: "horror" },
  { name: "Slice of Life", slug: "slice-of-life" },
  { name: "Mythology", slug: "mythology" },
  { name: "Fairy Tales", slug: "fairy-tales" },
  { name: "Supernatural", slug: "supernatural" },
  { name: "Drama", slug: "drama" },
  { name: "Comedy", slug: "comedy" },
  { name: "Romance", slug: "romance" }
];

export default blogCategories;
